import React from 'react';
import RenderContent from 'app/components/layout/RenderContent';
import { Route } from 'react-router-dom';
import MatchPaymentsList from './components/MatchPaymentsList';
import PaymentRequestsList from './components/PaymentRequestsList';
import PaymentDetail from './components/PaymentDetail';
import NewPaymentRequest from './components/NewPaymentRequest';
import PaymentRequestDetail from './components/PaymentRequestDetail';
import PaymentCollectionDetail from './components/PaymentCollectionDetail';
import MatchPaymentDetail from './components/MatchPaymentDetail';

interface IPaymentsLayoutProps {
  actions?: any;
  organisations?: any;
  match?: any;
}

export default class PaymentsLayout extends React.Component<IPaymentsLayoutProps> {
  render(): React.ReactNode {
    return (
      <RenderContent checkOrgLoaded className="payments-app" match={this.props.match}>
        <Route
          exact
          path={['/payments/segments/matches', '/payments/segments/matches\\::filterConfig']}
          render={(): React.ReactNode => (
            <MatchPaymentsList
              {...this.props}
            />
          )}
        />
        <Route
          exact
          path={['/payments/segments/requests', '/payments/segments/requests\\::filterConfig']}
          render={(): React.ReactNode => (
            <PaymentRequestsList
              {...this.props}
            />
          )}
        />
        <Route exact path="/payments" render={() => <MatchPaymentsList {...this.props} />} />
        {/* <Route
          exact
          path="/payments/:paymentRecordId"
          render={(): React.ReactNode => (
            <PaymentDetail {...this.props} {...this.props.paymentRecords} />
          )}
        /> */}
        <Route
          exact
          path={['/payments/segments/requests/new', '/payments/segments/requests/new/select', '/payments/segments/requests/new/notifications', '/payments/segments/requests/new/confirm']}
          render={() => <NewPaymentRequest {...this.props} />}
        />
        <Route
          exact
          path="/payments/segments/requests/detail/:paymentRequestId"
          render={() => <PaymentRequestDetail {...this.props} />}
        />
        <Route
          exact
          path="/payments/segments/requests/detail/:paymentRequestId/collection/:PaymentCollectionId"
          render={() => <PaymentCollectionDetail {...this.props} />}
        />
        <Route
          exact
          path="/payments/segments/matches/detail/:matchPaymentId"
          render={() => <MatchPaymentDetail {...this.props} />}
        />
      </RenderContent>
    );
  }
}
